import type { Json } from '../../../services/supabase/database.types'
import type { StatusItem } from '../../../types/domain'
import type { RequisicaoItemRow } from '../../requisicoes/types'
import type { BuyerChange, BuyerItemDraft } from '../types'
import { parseBuyerQuantity } from '../utils/buyer-status'

function nullable(value: string): string | null {
  const trimmed = value.trim()
  return trimmed || null
}

export function itemToBuyerDraft(item: RequisicaoItemRow): BuyerItemDraft {
  return {
    id: item.id,
    versao: item.versao,
    codigo: item.codigo,
    descricao: item.descricao,
    grade1: item.grade1,
    grade2: item.grade2,
    grade3: item.grade3,
    unidade: item.unidade,
    quantidade_solicitada: item.quantidade_solicitada,
    necessidade: item.necessidade,
    prioridade: item.prioridade,
    quantidade_comprada: item.quantidade_comprada === null ? '' : String(item.quantidade_comprada),
    fornecedor: item.fornecedor ?? '',
    prazo_entrega: item.prazo_entrega ?? '',
    status_item: item.status_item as StatusItem,
    observacao_comprador: item.observacao_comprador ?? '',
  }
}

export function buyerItemChanged(current: BuyerItemDraft, baseline: BuyerItemDraft): boolean {
  return parseBuyerQuantity(current.quantidade_comprada) !== parseBuyerQuantity(baseline.quantidade_comprada)
    || nullable(current.fornecedor) !== nullable(baseline.fornecedor)
    || nullable(current.prazo_entrega) !== nullable(baseline.prazo_entrega)
    || current.status_item !== baseline.status_item
    || nullable(current.observacao_comprador) !== nullable(baseline.observacao_comprador)
}

export function buyerDraftToChange(item: BuyerItemDraft): BuyerChange {
  return {
    id: item.id,
    versao: item.versao,
    quantidade_comprada: parseBuyerQuantity(item.quantidade_comprada),
    fornecedor: nullable(item.fornecedor),
    prazo_entrega: nullable(item.prazo_entrega),
    status_item: item.status_item,
    observacao_comprador: nullable(item.observacao_comprador),
  }
}

export function buildBuyerChanges(current: BuyerItemDraft[], baseline: BuyerItemDraft[]): BuyerChange[] {
  return current.filter((item) => {
    const original = baseline.find((candidate) => candidate.id === item.id)
    return original ? buyerItemChanged(item, original) : false
  }).map(buyerDraftToChange)
}

export function buyerChangesToJson(changes: BuyerChange[]): Json {
  return changes.map((change) => ({ ...change }))
}

export function rowMatchesBuyerChange(item: RequisicaoItemRow, change: BuyerChange): boolean {
  return item.id === change.id
    && item.versao > change.versao
    && item.quantidade_comprada === change.quantidade_comprada
    && item.fornecedor === change.fornecedor
    && item.prazo_entrega === change.prazo_entrega
    && item.status_item === change.status_item
    && item.observacao_comprador === change.observacao_comprador
}
